import { render } from "./audioMod.vue?vue&type=template&id=1ddba5f7&scoped=true"
import script from "./audioMod.vue?vue&type=script&lang=js"
export * from "./audioMod.vue?vue&type=script&lang=js"

import "./audioMod.vue?vue&type=style&index=0&id=1ddba5f7&scoped=true&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ddba5f7"]])

export default __exports__